(function () {
  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  function canInitPolaris() {
    return (
      typeof window.__reviewsioInitPolarisWidgets === 'function' &&
      typeof window.reviewsIoStore !== 'undefined' &&
      typeof window.ReviewsWidget === 'function' &&
      document.querySelector('[data-reviewsio-widget="polaris"]')
    );
  }

  function getPolarisTarget() {
    var explicitTarget = document.getElementById('shopify-product-reviews');
    if (explicitTarget) return explicitTarget;

    var polarisWidget = document.querySelector('[data-reviewsio-widget="polaris"]');
    if (!polarisWidget) return null;

    var wrapper = polarisWidget.closest('.app-wrapper') || polarisWidget;
    if (!wrapper.id) {
      wrapper.id = 'shopify-product-reviews';
    }

    return wrapper;
  }

  function initPolarisWhenReady() {
    var attempts = 0;
    var maxAttempts = 40;
    var retryDelayMs = 250;

    function tick() {
      attempts += 1;

      if (canInitPolaris()) {
        window.__reviewsioInitPolarisWidgets();
        return;
      }

      if (attempts < maxAttempts) {
        window.setTimeout(tick, retryDelayMs);
      }
    }

    tick();
  }

  function bindReviewSummaryLinks() {
    var target = getPolarisTarget();
    if (!target) return;

    document.querySelectorAll('.star-rating-container, .ruk_rating_snippet').forEach(function (node) {
      if (node.getAttribute('data-reviews-link-bound') === 'true') return;

      if (node.classList.contains('ruk_rating_snippet')) {
        node.style.cursor = 'pointer';
      }

      node.addEventListener('click', function (event) {
        event.preventDefault();

        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        if (history.replaceState) {
          history.replaceState(null, '', '#shopify-product-reviews');
        }
      });

      node.setAttribute('data-reviews-link-bound', 'true');
    });
  }

  if (!isProductPage()) return;

  window.addEventListener('load', initPolarisWhenReady);
  window.addEventListener('load', bindReviewSummaryLinks);
  document.addEventListener('shopify:section:load', initPolarisWhenReady);
  document.addEventListener('shopify:section:load', bindReviewSummaryLinks);
})();
